<template>
    <div class="vue-checkbox">
        <label
                :class="{
        'vue-checkbox--checked': isChecked,
        'vue-checkbox--bordered': type === 'border',
        'vue-checkbox--disabled': disabled
      }"
                class="vue-checkbox"
        >
            <input
                :id="`vue-checkbox-${_uid}`"
                :checked="isChecked"
                :name="name"
                :disabled="disabled"
                :value="value"
                type="checkbox"
                @change="onChange"
            >
            <div class="vue-checkbox__inner">
                <i
                    v-if="isChecked"
                    class="icon-check"
                />
            </div>
            <span class="vue-checkbox__label">
        <span v-if="label">{{ label }}</span>
        <slot v-else />
      </span>
        </label>
    </div>
</template>

<script>
export default {
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.checked
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean,
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isGroup () {
      return this.$parent.$options.name === 'FormCheckboxGroup'
    },
    isChecked () {
      if (!this.isGroup) return this.checked
      if (this.$parent.modelValue) {
        if (typeof this.value === 'object') {
          return !!this.$parent.modelValue.find(item => item.id === this.value.id)
        }
        if (typeof this.value === 'string' || typeof this.value === 'number') {
          return !!this.$parent.modelValue.find(item => item === this.value)
        }
      }
      return false
    }
  },
  methods: {
    onChange () {
      if (this.disabled) return
      if (!this.isGroup) return this.$emit('change', !this.checked)

      if (!this.isChecked) {
        this.$parent.value.push(this.value)
      } else {
        this.$parent.value.find(item => {
          if (typeof this.value === 'object') {
            this.$nextTick(() => {
              if (item.id === this.value.id) this.$parent.value.splice(this.$parent.value.indexOf(item), 1)
            })
          }
          if (typeof this.value === 'string' || typeof this.value === 'number') {
            this.$nextTick(() => {
              if (item === this.value) this.$parent.value.splice(this.$parent.value.indexOf(item), 1)
            })
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/Checkbox.vue